import { createStyleSheet } from '@shared-ui/theme'
import { rh } from '@shared-ui/theme/scale'
import type { ViewStyle } from 'react-native'

const appHeightStyle = {
  minHeight: 'var(--app-height)',
} as unknown as ViewStyle

export const useCreateStyles = createStyleSheet((_theme, { safe }) => ({
  wrapper: {
    flexGrow: 1,
    paddingTop: safe.top,
    // safe.bottom — физические px (home indicator / нижний chrome Safari). rh() его сжимает.
    paddingBottom: safe.bottom || rh(20),
    overflow: 'visible',
    ...appHeightStyle,
  },
  wrapperTransparent: {
    backgroundColor: 'transparent',
  },
  wrapperWithoutSafeTop: {
    paddingTop: 0,
  },
  wrapperWithoutScroll: {
    paddingTop: safe.top,
    paddingBottom: safe.bottom,
    flex: 1,
    minHeight: 0,
    position: 'relative',
    ...appHeightStyle,
  },
}))
